import { OnboardingStage } from './entities'

export const landingLink = 'https://nocoins.today'

export const onboardingStageByAction: Record<string, OnboardingStage> = {
    OnboardingActionVerifyEmail: 'email',
    OnboardingActionCreateStripeAccount: 'stripe',
}
